module.exports = __webpack_public_path__ + "static/media/epipen-email-header-black.0baccd39.png";